import { css } from "@emotion/react";

export const globalStyles = css`
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
    }
    body {
        margin: 0px;
    }
`;
